
<div *ngIf="isMediaDisable" class="image-upload-lbl">
    <span *ngIf="currentStep === 'ADD_WAY_POINT_DETAILS'; else tourGenerate">{{commonLables.ADD_MEDIA| translate }}</span>
    <ng-template #tourGenerate>
        <span>{{commonLables.ADD_COVER_IMG| translate }}</span>
    </ng-template>
    <span *ngIf="markMediaFieldsAsRequired">*</span>
</div>
<div class="media-area-style" >
    <div class="upload-media" for="fileField" id="add-media">
        <div class="image-upload" >

            <div class="add-img">
                <label for="file-input">
                    <span class="upload-icon image-upload-style"></span>
                </label>
                <input #myFileInput id="file-input" type="file" (change)="uploadMediaOnClk($event)" (click)="myFileInput.value=''" multiple="multiple"
                    accept=".jpg, .jpeg, .png," />
            </div>
            <ng-container>
                <div class="media-container"
                    *ngIf="(mediaFiles && mediaFiles.length>0)" (click)="showMediaGallery()">
                    <div *ngFor="let mediaFile of mediaFiles; let i = index" class="mediafile"
                        [ngClass]="{'remaining-med': i===2 && mediaFilesOverlay && mediaFilesOverlay.length>0}">
                        <span *ngIf="(i===2 && ((mediaFilesOverlay && mediaFilesOverlay.length>0) && showOverlayFlag))">+
                            {{mediaFilesOverlay.length}}</span>
                        <div class="img-tile-item">
                            <img [src]="mediaFile | safe" id="thumbnail-{{i+1}}" alt="'thumbnail'">
                        </div>
                    </div>
                </div>
            </ng-container>

        </div>
    </div>
</div>